import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type FinancialsTabularViewKey = 'actual-costs' | 'costs-by-clin';

type ViewState = {
  page: number;
  pageSize: number;
};

type FinancialsTabularState = {
  views: Record<FinancialsTabularViewKey, ViewState>;
};

// Backend tabular-data accepts pageSize up to 100 (max); default the UI to 100 so users
// see the most rows by default, with smaller options available via the page-size picker.
const DEFAULT_PAGE_SIZE = 100;

const initialState: FinancialsTabularState = {
  views: {
    'actual-costs': { page: 0, pageSize: DEFAULT_PAGE_SIZE },
    'costs-by-clin': { page: 0, pageSize: DEFAULT_PAGE_SIZE },
  },
};

export const financialsTabularSlice = createSlice({
  name: 'financialsTabular',
  initialState,
  reducers: {
    setViewPage: (
      state,
      action: PayloadAction<{ view: FinancialsTabularViewKey; page: number }>,
    ) => {
      state.views[action.payload.view].page = action.payload.page;
    },
    setViewPageSize: (
      state,
      action: PayloadAction<{
        view: FinancialsTabularViewKey;
        pageSize: number;
      }>,
    ) => {
      state.views[action.payload.view].pageSize = action.payload.pageSize;
      state.views[action.payload.view].page = 0;
    },
  },
});

export const { setViewPage, setViewPageSize } = financialsTabularSlice.actions;

export default financialsTabularSlice.reducer;
